import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetRequest } from '../../../../hooks/useGetRequest';
import SignatureImageView from './signatureImageView';
import { deleteConfirmation } from '../../../../utils/helpers';
import { useDeleteRequest } from '../../../../hooks/useDeleteRequest';

const SignatureView = ({
  isPad,
  prescriptionSetting,
  prescriptionItems,
  isPrescription = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const [imageContent, setImageContent] = useState('');
  const { doctorName } = userInfo;

  console.log('prescriptionItems: ', prescriptionItems?.items);

  const { isLoading: isGetImageLoading, refetch: getImageLoad } = useGetRequest(
    `getSignatureContent-${userInfo.id}`,
    `doctors/signature-content/${userInfo.id}`,
    (data) => {
      setImageContent(data);
    },
    (e) => {
      console.log(e);
    },
  );

  const { isLoading: isLoading, mutate: deleteSignature } = useDeleteRequest(
    `doctors/delete-signature/${userInfo.id}`,
    (data) => {
      setImageContent('');
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    getImageLoad();
  }, []);

  const signatureStyle = () => {
    return {
      bottom:
        prescriptionSetting?.footer?.height?.quantity +
        prescriptionSetting?.footer?.height?.unit,
      right: '25px',
      //position: 'absolute',
    };
  };

  const nl2br = (str) => str.replace(/\n/g, '<br>');

  return (
    <div
      className={`${isPrescription ? 'prescription-signature-view' : ''} ${
        userInfo?.signaturePosition && isPad ? 'signature-fixed' : ''
      }`}
      style={userInfo?.signaturePosition && isPad ? signatureStyle() : {}}
    >
      <div>
        {imageContent && (
          <SignatureImageView
            signature={imageContent}
            height={80}
            width={280}
          />
        )}
        {!isPrescription && imageContent && (
          <i
            className="fa fa-times-circle ml-3"
            style={{ fontSize: '18px' }}
            onClick={() => deleteConfirmation(deleteSignature, 23)}
          ></i>
        )}
      </div>
      {isPrescription && doctorName && (
        <div
          className="text-center mt-2 p-2 px-3"
          style={{
            borderTop: `${
              prescriptionItems?.items?.signature?.itemStyle?.underline
                ? '1px solid black'
                : ''
            }${
              prescriptionItems?.items?.signature?.itemStyle?.dottedUnderline
                ? '2px dotted black'
                : ''
            }`,
          }}
        >
          {doctorName.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(SignatureView);
